import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import "./../../../css/app.css";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import { useAlert } from "react-alert";

// This file requires images/mode/ BOTH statically and dynamically (see
// detectimagefortargetmode). The dynamic form makes webpack 5 build a context
// module for that directory, and a context returns the ES module NAMESPACE
// object - which has a null prototype. React then does '' + value when setting
// src, and throws "Cannot convert object to primitive value", blanking the page.
// webpack 4 returned a bare URL string, which is why this only appeared after
// the upgrade. Unwrap .default when present; harmless when it is already a string.
function assetUrl(m) {
  return m && typeof m === "object" && "default" in m ? m.default : m;
}

const SurfModeButtons = (props) => {
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  const alert = useAlert();
  const [state, setState] = useStateIfMounted({
    surftype: "",
    surfmode: "",
  });
  const mode_topic =
    mqtt_topics.fixed_topic_part + mac + "/" + mqtt_topics.modetopic;

  function requestdata() {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      mqtt_topics.modetopic,
    );
    mqtt_topics.busy_Requesting_Data = false;
    props.mqttClient.subscribe(mode_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == mode_topic) {
      try {
        // message is Buffer
        //console.log(topic, "From Surf Mode: " + message.toString());
        message = JSON.parse(message.toString());
        setState({
          surftype: message.Type == undefined ? "" : message.Type,
          surfmode: message.Mode == undefined ? "" : message.Mode,
        });
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    //console.log("FLAG " + mqtt_topics.busy_Requesting_Data);
    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata();
    } else {
      setTimeout(function () {
        requestdata();
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(mode_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    [],
  );

  function checkifemptystateofdata() {
    if (
      (state.surfmode == "" && state.surftype == "") ||
      (state.surfmode == undefined && state.surftype == undefined)
    ) {
      return true;
    }
    return false;
  }

  function detectimagefortargetmode(buttonid) {
    if (checkifemptystateofdata()) {
      return assetUrl(require("./../../../images/loading.gif"));
    } else {
      switch (buttonid) {
        case "mains_standby": {
          if (state.surftype.toLowerCase().indexOf("amfes") !== -1) {
            if (state.surfmode.toLowerCase().indexOf("mains") !== -1) {
              return assetUrl(require("./../../../images/mode/mains_on.png"));
            }
            return assetUrl(require("./../../../images/mode/mains.png"));
          } else {
            if (state.surfmode.toLowerCase().indexOf("standby") !== -1) {
              return assetUrl(require("./../../../images/mode/standby_on.png"));
            }
            return assetUrl(require("./../../../images/mode/standby.png"));
          }
        }
        default: {
          if (state.surfmode.toLowerCase().indexOf(buttonid) !== -1) {
            return assetUrl(require("./../../../images/mode/" + buttonid + "_on.png"));
          }
          return assetUrl(require("./../../../images/mode/" + buttonid + ".png"));
        }
      }
    }
  }
  function detecttitlefortargetmode(buttonid) {
    if (checkifemptystateofdata()) {
      return "Loading ...";
    } else {
      switch (buttonid) {
        case "mains_standby": {
          if (state.surftype.toLowerCase().indexOf("amf") !== -1) {
            return "Mains";
          } else {
            return "Standby";
          }
        }
        default: {
          return buttonid;
        }
      }
    }
  }
  function requesttochangemode(modetobe) {
    if (props.passlevel != "user") {
      props.mqttClient.publish(
        mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
        mqtt_topics.changemodetopic + modetobe,
      );
      setState({
        surftype: "",
        surfmode: "",
      });
    } else {
      alert.show("You don't have permission to perform this action.", {
        type: "error",
        position: "middle",
      });
    }
  } //{detecttitlefortargetmode("Manual")} {detecttitlefortargetmode("Auto")} {detecttitlefortargetmode("mains_standby")}

  return (
    <div className="row">
      <div className="col">
        <div className="card text-center bg-light modecards">
          <div className="card-body">
            <h5 className="card-title"></h5>
            <img
              className="mode"
              src={assetUrl(require("./../../../images/mode/off.png"))}
              onClick={() =>
                alert.show("Action is prohibited.", {
                  type: "error",
                  position: "middle",
                })
              }
            />
          </div>
        </div>
      </div>
      {mac != "0-6d-55" && ( //barok
        <div className="col">
          <div className="card text-center bg-light modecards">
            <div className="card-body">
              <h5 className="card-title"></h5>
              <img
                className="mode"
                src={detectimagefortargetmode("manual")}
                onClick={() => requesttochangemode("manual")}
              />
            </div>
          </div>
        </div>
      )}

      <div className="col">
        <div className="card text-center bg-light modecards">
          <div className="card-body">
            <h5 className="card-title"></h5>
            <img
              className="mode"
              src={detectimagefortargetmode("auto")}
              onClick={() => requesttochangemode("auto")}
            />
          </div>
        </div>
      </div>
      {mac != "0-6d-55" && ( //barok
        <div className="col">
          <div className="card text-center bg-light modecards">
            <div className="card-body">
              <h5 className="card-title"></h5>
              <img
                className="mode"
                src={detectimagefortargetmode("mains_standby")}
                onClick={() => requesttochangemode("mains_standby")}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default SurfModeButtons;
